import { Award, Trophy, Trash2 } from 'lucide-react';
import { useData, useApp } from '../context.jsx';
import { Composer, IconButton } from '../components/ui.jsx';

export default function Rewards() {
  const { data, updateData } = useData();
  const { drafts, setDrafts, addItem, removeItem } = useApp();

  return (
    <section className="view-grid">
      <section className="panel wide reward-hero">
        <div>
          <p className="eyebrow">Momentum</p>
          <h3>{data.points} points available</h3>
          <p>Complete chores to grow streaks and unlock custom rewards.</p>
        </div>
        <Award size={48} />
      </section>
      <Composer
        icon={Trophy}
        value={drafts.reward}
        placeholder="Add custom reward..."
        onChange={(value) => setDrafts((current) => ({ ...current, reward: value }))}
        onAdd={() => addItem('rewards', 'reward', (title) => ({ id: crypto.randomUUID(), title, cost: 50 }))}
      />
      <section className="panel wide">
        <div className="reward-grid">
          {data.rewards.map((item) => (
            <div className="reward-card" key={item.id}>
              <div>
                <h4>{item.title}</h4>
                <p>{item.cost} pts</p>
              </div>
              <button
                className="primary-button"
                disabled={data.points < item.cost}
                onClick={() => updateData((current) => ({ ...current, points: current.points - item.cost }))}
                type="button"
              >
                Redeem
              </button>
              <IconButton label="Remove" icon={Trash2} onClick={() => removeItem('rewards', item.id)} />
            </div>
          ))}
        </div>
      </section>
    </section>
  );
}
